<template>
  <b-container fluid>
    <b-row>
      <b-table v-if="role === 2 || role === 1" striped hover :items="aiExecResult" :fields="fields" :thead-class="'table-header'"  :tbody-tr-class="rowClass" class="m-2 h-100">

        <template v-slot:cell(buttons)="data" class="td-right">
          <div class="vertical-center">
            <nobr>
              <b-button v-if="data.item.executionStatus === 1" variant="outline-success" @click="editClientAnalit(data.item)" class="ml-1"  title="Открыть"><b-icon icon="eye-fill"></b-icon> Открыть</b-button>
            </nobr>
          </div>
        </template>
        <template v-slot:cell(createDate)="data" class="">
          <div class="vertical-center font-weight-bold">{{data.item.createDate}}</div>
        </template>
        <template v-slot:cell(aiPromptName)="data" class="">
          <div class="vertical-center">{{data.item.aiPromptName}}</div>
        </template>
        <template v-slot:cell(executionStatusText)="data" class="">
          <div class="vertical-center">
            <b-icon v-if="data.item.executionStatus === 1" variant="success" style="stroke-width: 2;" icon="check-circle"></b-icon>
            <b-icon v-else-if="data.item.executionStatus === 2" variant="danger"  style="stroke-width: 2;" icon="x-circle"></b-icon>
            <b-icon v-else variant="warning" icon="arrow-clockwise"></b-icon>
            &nbsp;
            <span :class="data.item.executionStatus === 1 ? 'text-success' : (data.item.executionStatus === 2 ? 'text-danger' : 'text-warning')" style="font-weight: bold!important;"> {{data.item.executionStatusText}}</span>
          </div>
        </template>
      </b-table>
    </b-row>
    <b-modal id="createClientReportParamModal" no-close-on-backdrop no-close-on-esc hide-footer size="xl" :title="selectedResult.createDate + ' ' + selectedResult.aiPromptName">
      <b-container fluid>
        <span v-html="selectedResult.responseText"></span>
      </b-container>
    </b-modal>
  </b-container>
</template>

<script>

import {host} from "@/constants";
import markdownit from 'markdown-it'
export default {
  props: ["patientId"],
  name: "PatientAiReportExecutionList",
  computed: {
    role: {
      get() {
        return this.$store.getters.role
      }
    },
    permission: {
      get() {
        return this.$store.getters.permission
      }
    }
  },
  data() {
    return {
      selectedResult: {
        aiPromptExecutionId: null,
        responseText: "",
        createDate: null,
        aiPromptName: ''
      },
      fields: [
        {
          key: 'createDate',
          label: 'Дата отчёта',
          thClass: 'table-header ',
          tdClass: ''
        },
        // {
        //   key: 'createDate',
        //   label: 'Дата формирования отчета'
        // },
        {
          key: 'aiPromptName',
          label: 'Задача',
          thClass: 'table-header ',
          tdClass: ''
        },
        {
          key: 'executionStatusText',
          label: 'Статус',
          thClass: 'table-header',
          tdClass: ''
        },
        {
          key: 'buttons',
          label: '',
          thClass: 'table-header',
          tdClass: 'td-right'
        }

      ],
      aiExecResult: []
    }
  },
  methods: {
    async fetchData() {
      fetch(host + '/rest/ai-reports/ai-promt-execs/' + this.patientId, {
        credentials: "include"
      })
          .then(response => response.json())
          .then(json => {


            this.aiExecResult = json.promtExecutions


            //console.log(JSON.stringify(json))
          }).catch(error => {
        console.log(error)
        this.loading = false
      })
    },
    rowClass(item, type = 'row') {
      return 'table-row-white'
      // if (!item || type !== 'row') return
      // if (item.executionStatus === 1) return 'table-row'
      // else if (item.executionStatus === 2) return 'table-row'
      // else return 'table-row'
    },
    selectResult(item) {
      //console.log("Select Result " + item)
      this.selectedResult = item
    },
    editClientAnalit(item = null) {
      this.selectedResult = item
      this.$bvModal.show('createClientReportParamModal')
    },
  },
  async mounted() {

    await this.fetchData()
  },
}
</script>

<style scoped>



</style>